import { Exclude } from 'class-transformer';
import { DimensionSelectorResultDto } from './dimension-selector-result-dto';

export class DimensionOptionCodeRawDto {
    dimensionCode: string;
    dimensionOptionCode: string;

    // Transient
    @Exclude()
    dimension: DimensionSelectorResultDto;
    getDimension(results: DimensionSelectorResultDto[]): DimensionSelectorResultDto {
        return results.find((r) => r.code === this.dimensionCode);
    }
}
